module.exports = __webpack_public_path__ + "img/ic_delete.04dd7423.svg";